import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ACTION_CARD_EVENT,
  ACTION_EVENT,
  DOCUMENT_STATES,
  NEW_ACTION_LABEL,
  USER_DATA_ACTION,
  USER_DATA_ACTION_ARRAY,
  USER_EDITION,
  USER_EDITION_FIELD
} from "../../constants/ActionConstants";
import { ActionId } from "../../models/ActionId";
import { ActionParameters } from "../../models/ActionParameters";
import SearchSelect from "./SearchSelect/SearchSelect.vue";
import ActionTabsError from "./ActionTabsError/ActionTabsError.vue";
import Vuetify from "vuetify";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import { ActionError } from "../../models/ActionTask";
import { List } from "@/shared/components/GenericSearchBar/model/List";

Vue.use(Vuetify);
@Component({
  components: {
    SearchSelect,
    ActionTabsError
  }
})
export default class UserFieldsDialog extends Vue {
  @Prop() private dialog!: boolean;
  @Prop() private userIdArray!: ActionId[];
  @Prop() private userRoleList!: RoleInfo[];
  @Prop() private dependenciesList!: Dependency[];
  @Prop() private dependenciesToRemoveList!: Dependency[];
  @Prop() private userInfoGroups!: HeaderInfoGroup[];
  @Prop() private errors!: ActionError[];
  @Prop() private success!: ActionError[];
  @Prop() private statesToUserFieldsAction!: List[];

  selectedData = "";
  selectedState = "";
  selectedAddRole = "";
  selectedDeleteRole = "";
  selectedAddInfoGroup = "";
  selectedAddDependency = "";
  selectedDeleteDependency = "";

  USER_DATA_ACTION = USER_DATA_ACTION;
  isValid = false;

  TITLE = USER_EDITION;
  CONFIGURATION = USER_EDITION_FIELD;
  NEW_ACTION_BTN_LABEL = NEW_ACTION_LABEL.NEW_ACTION_BTN_LABEL;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  DATA_SELECT = NEW_ACTION_LABEL.SELECT_CHOOSE_DATA;
  SELECT_STATE = NEW_ACTION_LABEL.SELECT_STATE;
  SELECT_ROLE = NEW_ACTION_LABEL.SELECT_ROLE;
  SELECT_INFO_GROUP = NEW_ACTION_LABEL.SELECT_INFO_GROUP;
  SELECT_DEPENDENCY = NEW_ACTION_LABEL.SELECT_DEPENDENCY;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnClassSecondary = STYLE_CLASSES.SECONDARY_BTN;

  selectDataArray: { title: string; value: string }[] = USER_DATA_ACTION_ARRAY;
  selectStateArray: List[] = this.statesToUserFieldsAction;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  cancelAction() {
    let search = true;
    if (
      (this.errors.length > 0 && this.success.length == 0) ||
      (this.errors.length == 0 && this.success.length == 0)
    )
      search = false;
    this.$emit(ACTION_CARD_EVENT.CANCEL_DATA, search);
  }

  executeAction() {
    const newAction = this.fillNewAction();
    this.$emit(ACTION_CARD_EVENT.SEND_DATA_ACTION, newAction);
  }

  @Watch("selectedData")
  dataChanged() {
    this.selectedState = "";
    this.selectedAddRole = "";
    this.selectedDeleteRole = "";
    this.selectedAddInfoGroup = "";
    this.selectedAddDependency = "";
    this.selectedDeleteDependency = "";
  }

  selectedRole(selectedRole: string) {
    const role = this.userRoleList.find(role => role.name === selectedRole);
    if (this.selectedData === USER_DATA_ACTION.ADD_ROLE) {
      this.selectedAddRole = role ? role.id : "";
    } else if (this.selectedData === USER_DATA_ACTION.REMOVE_ROLE) {
      this.selectedDeleteRole = role ? role.id : "";
    }
  }

  selectedDependency(selectedDependency: string) {
    const dependency = this.dependenciesList.find(
      dependency => dependency.name === selectedDependency
    );
    this.selectedAddDependency =
      dependency && dependency.id ? dependency.id : "";
  }

  selectedDependencyToRemove(selectedDependency: string) {
    const dependency = this.dependenciesToRemoveList.find(
      dependency => dependency.name === selectedDependency
    );
    this.selectedDeleteDependency =
      dependency && dependency.id ? dependency.id : "";
  }

  selectedInfoGroup(selectedInfoGroup: string) {
    const infoGroup = this.userInfoGroups.find(
      infoGroup => infoGroup.name === selectedInfoGroup
    );
    if (this.selectedData === USER_DATA_ACTION.EXTRA_INFO_GROUP) {
      this.selectedAddInfoGroup = infoGroup ? infoGroup._key : "";
    }
  }

  fillNewAction(): ActionParameters {
    const newAction: ActionParameters = {
      ids: this.userIdArray,
      type: ACTION_EVENT.DATA,
      user: {
        addRole: this.selectedAddRole !== "" ? this.selectedAddRole : undefined,
        removeRole:
          this.selectedDeleteRole !== "" ? this.selectedDeleteRole : undefined,
        addDependency:
          this.selectedAddDependency !== ""
            ? this.selectedAddDependency
            : undefined,
        removeDependency:
          this.selectedDeleteDependency !== ""
            ? this.selectedDeleteDependency
            : undefined,
        extraInfoGroups:
          this.selectedAddInfoGroup !== ""
            ? this.selectedAddInfoGroup
            : undefined,
        state:
          this.selectedState !== ""
            ? this.selectedState === DOCUMENT_STATES.ACTIVE
            : undefined
      }
    };
    return newAction;
  }

  showAcceptButton() {
    return (
      this.errors &&
      this.errors.length == 0 &&
      this.success &&
      this.success.length == 0
    );
  }

  searchRoleByName(name: string) {
    this.$emit(ACTION_CARD_EVENT.SEARCH_ROLE_BY_NAME, name);
  }
  searchDependencyByName(name: string) {
    this.$emit(ACTION_CARD_EVENT.SEARCH_DEPENDENCY_BY_NAME, name);
  }
  searchInfoGroupByName(name: string) {
    this.$emit(ACTION_CARD_EVENT.SEARCH_INFO_GROUP_BY_NAME, name);
  }
}
